import DialChart from "../molecules/DialChart";
import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailBlackhead({data, img}) {
    return (
        <MeasurementResult 
            type="블랙헤드" 
            description="블랙헤드는 주로 피지, 세포 조각 및 박테리아로 구성된 면포가 모공을 막는 형태로 형성되며, 공기 중의 먼지, 오염물 및 산화 작용이 더해지면서 공기와 접촉하는 부분이 점차 검은 색으로 변합니다."
            score={data.score}
        >
            

            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />
                        <img src={img.image_mark_black_head_front} />

                        <div className="caption">화이트 라이트</div>
                    </div>
                </div>

                <DegreeSection 
                    type="블랙헤드"
                    badge={data.analysisBadge}
                    items={[
                        {
                            value: "없음",
                            level: 0
                        },
                        {
                            value: "경도",
                            level: 1
                        },
                        {
                            value: "중간 정도",
                            level: 2
                        },
                        {
                            value: "중증 정도",
                            level: 3
                        },
                    ]}
                    level={data.level}
                    text={data.degreeText}
                    line={3}
                />

                <section className="flex-content-center">
                    <div className="h4">블랙헤드 / 코면적 점유비율</div>
                    <div className="h-100 d-flex align-items-center">
                        <DialChart value={data.percentage} />
                    </div>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult} 
                />
            </div>
        </MeasurementResult>
    )
}